import * as React from 'react';

import classnames from 'classnames';

import {BulletedList} from '../bulleted-list/bulleted-list';
import {Button} from '../button/button';
import {Header} from '../typography/header';
import {Subheader} from '../typography/subheader';

import styles from './empty-state-large.module.css';

type DetailTextBullet = React.ReactNode | string;

type Props = {
    icon: any;
    iconSide: 'left' | 'right';
    title: React.ReactNode | string;
    subtitle?: React.ReactNode | string;
    detailTextBullets?: DetailTextBullet[];
    cta?: React.ReactNode;
    secondaryCta?: React.ReactNode;
    dismissal?: {
        title: string;
        onClick: () => void;
    };
};

EmptyStateLarge.defaultProps = {
    iconSide: 'left',
};

export function EmptyStateLarge(props: Props) {
    return (
        <div className={classnames('flex flex-dir-col align-center', styles.container)}>
            <div
                className={classnames(
                    'flex flex-dir-col align-center justify-center',
                    styles['empty-text']
                )}
            >
                <Header>{props.title}</Header>
                <Subheader>{props.subtitle}</Subheader>
            </div>
            <div
                className={classnames(
                    'flex align-center justify-center',
                    props.detailTextBullets
                        ? styles['details-container--with-text']
                        : styles['details-container']
                )}
            >
                {props.iconSide === 'left' ? <div>{props.icon}</div> : undefined}
                {props.detailTextBullets ? (
                    <div>
                        <BulletedList bullets={props.detailTextBullets} size='big' />
                    </div>
                ) : undefined}
                {props.iconSide === 'right' ? <div>{props.icon}</div> : undefined}
            </div>
            <div className={styles['action-container']}>
                <div
                    className={classnames(
                        'flex justify-center',
                        props.secondaryCta
                            ? styles['cta-container--two-column']
                            : styles['cta-container']
                    )}
                >
                    <div>{props.cta}</div>
                    {props.secondaryCta ? <div>{props.secondaryCta}</div> : undefined}
                </div>
                {props.dismissal ? (
                    // @ts-expect-error
                    <Button variant='text-secondary' onClick={props.dismissal.onClick}>
                        {props.dismissal.title}
                    </Button>
                ) : undefined}
            </div>
        </div>
    );
}
